<!--  -->
<template>
  <div>
    <div class="tencent-video-time">
      <div class="dis-24">Starting time：{{appDetail.mentorResultTimeStr}} ({{appDetail.mentorZone | zoneTitleMap}})</div>
      <div class="dis-12">Time elapsed：{{Math.floor(usedTime/60)}}mins</div>
      <template v-if="$route.name !== 'mentee-mock-zoom'">
        <!-- dis-48 -->
        <div class="dis-24">
          <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
          <span v-else>{{appDetail.module | moduleTitleMap }}</span> (Remaining time)：{{remainTime.remainTime}}mins</div>
        <div class="dis-12">
          <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
          <span v-else>{{appDetail.module | moduleTitleMap }}</span> (Max time)：{{remainTime.maxTime}}mins</div>
          <!-- dis-48 -->
        <div class="dis-24">
          <span v-if="isPackageId && (appDetail.module === 'MODULE_1')">PS Brainstorming</span>
          <span v-else>{{appDetail.module | moduleTitleMap }}</span> (Used time)：{{remainTime.usedTime}}mins</div>
      </template>
    </div>
    <template>
      <div class="tencent-video-btn">
        <Button class="zlr-btn-primary endTime"
                @click="isEndTime = true"
                v-if="isLinkVideo">End chat</Button>
      </div>
    </template>
    <!-- 确定要结束时间吗 -->
    <zlr-modal v-model="isEndTime">
      <div class="sure-video-end">
        <h1>Do you really want to end the video chat?</h1>
        <div class="sur-video-btn">
          <Button class="zlr-btn-default"
                  @click="isEndTime = false">Cancel</Button>
          <Button class="zlr-btn-primary"
                  @click="handleEnd">Sure</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>
<script>
// api
import { getAppRemainTime } from '@/api/appointment'
// components
import ZlrModal from '_c/modal/modal'
export default {
  name: 'tencent-video-time',
  components: {
    ZlrModal
  },
  props: ['appDetail', 'isLinkVideo', 'usedTime', 'isPackageId'],
  data () {
    return {
      remainTime: {},
      isEndTime: false
    }
  },
  computed: {},
  mounted () {
    this.getAppRemainTime()
  },
  methods: {
    getAppRemainTime () {
      let appDetail = this.appDetail
      getAppRemainTime({
        'id': appDetail.id
      }).then(res => {
        this.remainTime = res.data.model
      })
    },
    // 确定断开连接
    handleEnd () {
      this.isEndTime = false
      this.$emit('on-close')
    }
  },
  watch: {
    appDetail () {
      this.getAppRemainTime()
    }
  }
}
</script>
<style lang='less' scoped>
.sure-video-end {
  h1 {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.8);
    text-align: center;
    margin-bottom: 40px;
  }
  .sur-video-btn {
    text-align: center;
    button {
      margin: 0 20px;
    }
  }
}
</style>
